import MasterDataPage from "../common/MasterDataPage"
import { sportsApi } from "../../../service/certificate"

const CertSports = () => (
  <MasterDataPage
    config={{
      title: "Sports",
      subtitle: "Sports master list for sports / winner certificates",
      api: sportsApi as any,
      columns: [{ title: "Name", dataIndex: "name" }],
      fields: [{ name: "name", label: "Name", required: true, placeholder: "e.g. Football, Cricket, Swimming" }],
    }}
  />
)

export default CertSports
